// Bring in jQuery as an Externals dependency
import $ from 'jquery';

function anchorScroll() {
    $.fn.focusNoScroll = function () {
        const x = window.scrollX
        const y = window.scrollY;
        this.focus();
        window.scrollTo(x, y);
        return this;
    };

    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('.leadershipMain__catsTarget')
        .click(function (event) {
            // On-page links
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                // Figure out element to scroll to
                let target = $(this.hash);
                target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 76
                    }, 1000, () => {
                        // Callback after animation
                        // Must change focus!
                        const $target = $(target);
                        $target.focusNoScroll();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        }

                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        $target.focusNoScroll(); // Set focus again

                        return true;
                    });
                }
            }
        });
}

/**
 * Function to run when this module is called from site.js
 */
const init = () => {
    anchorScroll();
};

export default init;
